// 路由路径常量
export const loginPath = '/login';
export const registerPath = '/register';
export const homePath = '/';
export const listingPath = '/listing';
export const adminListPath = '/admin/list';
export const shopAuthPath = '/authorization/shop-authorization';

